import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ConnectivityService, NetworkStatus } from 'src/app/_service/connectivity.service';

@Component({
  selector: 'app-network-banner',
  templateUrl: 'networkbanner.component.html',
  styleUrls: ['./networkbanner.component.css']
})
export class NetworkbannerComponent implements OnInit {
  @Output() visibleChange = new EventEmitter<boolean>();

  status: NetworkStatus = 'online';
  wasOffline = false;

  constructor(private connectivity: ConnectivityService) {}

  ngOnInit() {
    this.connectivity.status$.subscribe(status => {
      if (status === 'offline' || status === 'poor') {
        this.wasOffline = true;
        this.visibleChange.emit(true);
      }
      this.status = status;

      if (status === 'online' && this.wasOffline) {
        this.visibleChange.emit(true);
        setTimeout(() => {
          this.wasOffline = false;
          this.visibleChange.emit(false);
        }, 3000);
      }
      if (status === 'online' && !this.wasOffline) {
        this.visibleChange.emit(false);
      }
    });
  }

  getMessage(status: NetworkStatus) {
    switch (status) {
      case 'offline':
        return 'No internet connection';
      case 'poor':
        return 'Your connection is unstable';
      default:
        return '';
    }
  }
}